import { render, staticRenderFns } from "./HubsCard.vue?vue&type=template&id=40f1de28"
import script from "./HubsCard.vue?vue&type=script&lang=ts"
export * from "./HubsCard.vue?vue&type=script&lang=ts"
import style0 from "./HubsCard.vue?vue&type=style&index=0&id=40f1de28&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports